import React from 'react';
import { useIntl } from 'react-intl';
// import { NoResults } from '@redturtle/volto-io-studio/components/';
import { UniversalLink } from '@plone/volto/components';
import { Tab, TabList, TabPanel, Tabs } from 'react-aria-components';
import { defineMessages } from 'react-intl';
import { Table } from 'semantic-ui-react';

const messages = defineMessages({
  search: {
    id: 'structurelisting_search',
    defaultMessage: "Cerca per nome dell'insegnamento o del docente",
  },
  descrizione: {
    id: 'structurelisting_descrizione',
    defaultMessage: 'Descrizione',
  },
  docente: {
    id: 'structurelisting_docente',
    defaultMessage: 'Docente',
  },
  ore: {
    id: 'structurelisting_ore',
    defaultMessage: 'Ore',
  },
  code: {
    id: 'structurelisting_code',
    defaultMessage: 'Codice',
  },
  cfu: {
    id: 'structurelisting_cfu',
    defaultMessage: 'CFU',
  },
  periodo: {
    id: 'structurelisting_periodo',
    defaultMessage: 'Periodo',
  },
  anno: {
    id: 'structurelisting_anno',
    defaultMessage: 'Anno {year}',
  },
  other: {
    id: 'structurelisting_other',
    defaultMessage: 'Altre attività formative',
  },
});

// {/* https://www.npmjs.com/package/react-responsive-tabs */}
const StructureDiagram = ({ items }) => {
  const intl = useIntl();
  const get_item_pds_id = (item) =>
    item.pds ? `${item.pds} ${item.anno}` : item.anno;
  const get_item_pds_title = (item) =>
    item.pds
      ? item.anno === 0
        ? `${item.pds} - ${intl.formatMessage(messages.other)}`
        : `${item.pds} - ${intl.formatMessage(messages.anno, {
            year: item.anno,
          })}`
      : item.anno === 0
      ? intl.formatMessage(messages.other)
      : intl.formatMessage(messages.anno, { year: item.anno });

  const tabs =
    items &&
    items.map((item) => ({
      id: get_item_pds_id(item),
      title: get_item_pds_title(item),
      pds: item.pds,
      anno: item.anno,
    }));

  return (
    <Tabs className="piano-didattico">
      <TabList items={tabs}>
        {(item) => (
          <Tab>{item.title}</Tab>
          //   {item.pds ? (
          //     <>
          //       {item.pds}
          //       <br />- anno {item.anno}
          //     </>
          //   ) : (
          //     <>Anno {item.anno}</>
          //   )}
          // </Tab>
        )}
      </TabList>
      {items.map((item, index) => (
        <TabPanel key={index} id={get_item_pds_id(item)}>
          <h3>{get_item_pds_title(item)}</h3>
          {Object.entries(
            Object.groupBy(item.units || [], (unit) => unit.taf?.code),
          )
            .toSorted((a, b) => (a[0] > b[0] ? 1 : -1))
            .map(([taf_code, units]) => (
              <div
                className="item-wrapper"
                basic
                key={`${item.anno}-${taf_code}`}
              >
                <h4>• {units[0].taf?.desc}</h4>
                {/* <pre>{JSON.stringify(units.sort((a, b) => a.desc > b.desc ? 1 : -1).map((u) => u.desc), null, 2)}</pre> */}
                <Table className="teachins-table">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell className="two wide column">
                        {intl.formatMessage(messages.code)}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="six wide column">
                        {intl.formatMessage(messages.descrizione)}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="four wide column">
                        {intl.formatMessage(messages.docente)}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="two wide column">
                        {intl.formatMessage(messages.cfu)}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="two wide column">
                        {intl.formatMessage(messages.periodo)}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="two wide column">
                        {intl.formatMessage(messages.ore)}
                      </Table.HeaderCell>
                      {/* <Table.HeaderCell className="one wide column">
                            obbligatorio
                          </Table.HeaderCell> */}
                      {/* <Table.HeaderCell>taf</Table.HeaderCell> */}
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {units
                      .sort((a, b) => (a.desc > b.desc ? 1 : -1))
                      .map((unit, index) => (
                        <Table.Row key={`unit-${index}`}>
                          <Table.Cell>{unit.code}</Table.Cell>
                          <Table.Cell>
                            {unit.url ? (
                              <UniversalLink href={unit.url}>
                                {unit.desc}
                              </UniversalLink>
                            ) : (
                              unit.desc
                            )}
                          </Table.Cell>
                          <Table.Cell>
                            {unit.doc &&
                              (unit.doc.url ? (
                                <UniversalLink href={unit.doc.url}>
                                  {unit.doc.nome} {unit.doc.cognome}
                                </UniversalLink>
                              ) : (
                                `${unit.doc.nome} ${unit.doc.cognome}`
                              ))}
                          </Table.Cell>
                          <Table.Cell>{unit.cfu || '-'}</Table.Cell>
                          <Table.Cell>{unit?.periodo?.desc || '-'}</Table.Cell>
                          <Table.Cell>{unit?.ore || '-'}</Table.Cell>
                          {/* <Table.Cell>{unit.obbligatorio && 'x'}</Table.Cell> */}
                          {/* <Table.Cell style={{ display: 'none' }}>
                                <pre>{JSON.stringify(unit, null, 2)}</pre>
                              </Table.Cell> */}
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </div>
            ))}
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default StructureDiagram;
